import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';

import { zonesCategoriesSelector } from 'core/redux/selectors/categories';

import Loader from 'core/react/general/Loader';
import TagPicker from 'core/react/general/form/TagPicker';

interface IZonesCategoriesSelectProps {
  disabled: boolean;
  initialValue: number[];
  value: number[];
  onChange: (value: number[]) => void;
}

export const ZonesCategoriesSelect: FC<IZonesCategoriesSelectProps> = (props) => {
  const { disabled, initialValue, value, onChange } = props;

  const zonesCategories = useSelector(zonesCategoriesSelector);

  const { fc } = useI18n();

  const options = zonesCategories.list?.map(({ categoryId, name }) => ({ value: categoryId, label: name }));

  return (
    <div className="event-type-picker">
      {zonesCategories ? (
        <TagPicker
          data={options || []}
          value={value}
          onChange={onChange}
          placeholder={fc('select categories')}
          label={fc('tags')}
          defaultValue={initialValue}
          disabled={disabled}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};
